const parseCsvLine = (line) => {
  const result = []
  let current = ''
  let inQuotes = false
  for (let i = 0; i < line.length; i++) {
    const char = line[i]
    if (inQuotes) {
      if (char === '"') {
        if (line[i + 1] === '"') {
          current += '"'
          i++
        } else {
          inQuotes = false
        }
      } else {
        current += char
      }
    } else if (char === '"') {
      inQuotes = true
    } else if (char === ',') {
      result.push(current)
      current = ''
    } else {
      current += char
    }
  }
  result.push(current)
  return result
}

export const parseCsv = (text) => {
  const lines = text.split(/\r?\n/).filter((line) => line.length > 0)
  if (lines.length === 0) return []
  const headers = parseCsvLine(lines[0])
  return lines.slice(1).map((line) => {
    const values = parseCsvLine(line)
    const row = {}
    headers.forEach((header, i) => {
      row[header] = values[i] ?? ''
    })
    return row
  })
}

const csvEscape = (value) => {
  const str = String(value ?? '')
  if (/[",\n]/.test(str)) return `"${str.replace(/"/g, '""')}"`
  return str
}

export const rowsToCsv = (rows) => {
  if (rows.length === 0) return ''
  const headers = Array.from(
    rows.reduce((set, row) => {
      Object.keys(row).forEach((key) => set.add(key))
      return set
    }, new Set()),
  )
  const lines = [headers.join(',')]
  rows.forEach((row) => {
    lines.push(headers.map((header) => csvEscape(row[header])).join(','))
  })
  return lines.join('\n')
}

const xmlEscape = (value) =>
  String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')

export const rowsToXml = (rows) => {
  const items = rows
    .map((row) => {
      const fields = Object.entries(row)
        .map(([key, value]) => `    <${key}>${xmlEscape(value)}</${key}>`)
        .join('\n')
      return `  <item>\n${fields}\n  </item>`
    })
    .join('\n')
  return `<?xml version="1.0" encoding="UTF-8"?>\n<items>\n${items}\n</items>`
}

export const xmlToRows = (text) => {
  const doc = new DOMParser().parseFromString(text, 'application/xml')
  if (doc.querySelector('parsererror')) {
    throw new Error('XML inválido.')
  }
  return Array.from(doc.documentElement.children).map((itemNode) => {
    const row = {}
    Array.from(itemNode.children).forEach((field) => {
      row[field.tagName] = field.textContent
    })
    return row
  })
}

export const rowsFromJson = (text) => {
  const parsed = JSON.parse(text)
  return Array.isArray(parsed) ? parsed : [parsed]
}

export const DATA_FORMATS = ['csv', 'json', 'xml']

export const convertData = (text, from, to) => {
  const rows = from === 'csv' ? parseCsv(text) : from === 'json' ? rowsFromJson(text) : xmlToRows(text)
  if (to === 'csv') return rowsToCsv(rows)
  if (to === 'json') return JSON.stringify(rows, null, 2)
  return rowsToXml(rows)
}
